export default "__VITE_ASSET__DnOSVU6o__"